/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dialog, Button, CustomCheckBox, Image, Anchor } from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import editIcon from "@icons/ic-edit-blue.svg";
import closeIcon from "@icons/ic-close-white.svg";
import "../../AddEditQuote.scss";
import {
  addSpace,
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
} from "@utils/utils";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  OptionsWrapper,
  SectionContainer,
  GridRow,
  EnquiryHeaderWrapper,
  FlexRow,
  ServiceSection,
  Separator,
  SellingPriceLabel,
  MarginDiv,
  GrayDarkerServiceSpan,
  GraySpan,
  GrayDarkerSpan,
} from "./QuoteServices.styled";

const SelectSellingPrice = (props) => {
  const {
    t,
    id,
    onClose,
    enquiryList,
    siteId,
    selectedSellingPrice,
    setSelectedSellingPrice,
    setCurrentSellingPrice,
    editSellingPrice,
    addSellingPrice,
    setEnquiryData,
    isLoading,
    sellingPriceArray,
    setSellingPriceArray,
  } = props;
  const [selectSellingPriceAPIError, setSelectSellingPriceAPIError] =
    useState("");
  const [isSellingPriceSelect, setIsSellingPriceSelect] = useState(false);

  const editSellingPriceAction = (data, enquiry) => {
    setCurrentSellingPrice(data);
    setEnquiryData(enquiry);
    editSellingPrice(data?.id);
  };

  const addSellingPriceAction = () => {
    addSellingPrice();
    setCurrentSellingPrice([]);
    setEnquiryData([]);
  };

  const handlePriceSelection = (e, sellingPriceId, sellingPriceData) => {
    const selectedSellingPriceArray = selectedSellingPrice;
    const selectedSellingPriceInfoArray = sellingPriceArray;
    if (e.target.checked) {
      if (selectedSellingPriceArray.indexOf(sellingPriceId) === -1) {
        setSelectedSellingPrice([...selectedSellingPriceArray, sellingPriceId]);
      }
      selectedSellingPriceInfoArray[sellingPriceId] = sellingPriceData;
      setSellingPriceArray(selectedSellingPriceInfoArray);
    }
    if (!e.target.checked) {
      const index = selectedSellingPriceArray.indexOf(sellingPriceId);

      if (index !== -1) {
        selectedSellingPriceArray.splice(index, 1);
        setSelectedSellingPrice([...selectedSellingPriceArray]);
        const sellingPriceIndex =
          selectedSellingPriceInfoArray.indexOf(sellingPriceId);
        selectedSellingPriceInfoArray.splice(sellingPriceIndex, 1);
        setSellingPriceArray(selectedSellingPriceInfoArray);
      }
    }
  };

  return (
    <Dialog width="65rem;">
      <div>
        <HeaderWrapper>
          <Title>{t("QUOTE_SELLING_PRICES_SELECTION_HEADER")}</Title>
          <Button
            onClick={() => onClose("close")}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image src={closeIcon} alt="close meeting report popup" />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <SectionContainer>
              {(enquiryList?.length === "" || enquiryList?.length === 0) && (
                <GridRow
                  column="1fr"
                  gap="0rem"
                  marginTop="20px"
                  marginLeft="20px"
                >
                  {" "}
                  <GraySpan>{t("NO_ENQUIRY")}</GraySpan>
                  <Separator marginTop="0px"></Separator>
                </GridRow>
              )}

              {isLoading && (
                <GridRow
                  column="1fr"
                  gap="0rem"
                  marginTop="20px"
                  marginLeft="20px"
                >
                  <div className="suggestions-list-loading">
                    <PulseLoader color="#1bace4" size={15} />
                  </div>
                </GridRow>
              )}

              {enquiryList?.length > 0 &&
                !isLoading &&
                enquiryList.map((enquiry, enquiryIndex) => {
                  return (
                    <React.Fragment key={"quoteEnquiry" + enquiry.id}>
                      <EnquiryHeaderWrapper
                        backgroundColor="#008395"
                        marginTop={enquiryIndex === 0 ? "0px" : "10px;"}
                      >
                        <FlexRow>
                          <Title>
                            {t("ENQUIRY")}{" "}
                            <Anchor
                              url={`/site/view/${siteId}/enquiry-view-${enquiry.id}`}
                              target="_blank"
                              className="add-quote__selling-price-link"
                            >
                              {" #" + enquiry?.id}
                            </Anchor>
                            {" - "}
                            {enquiry.service === "EVACUATION"
                              ? t("PRODUCTS_FILTER_REMOVAL") + " - "
                              : enquiry.service === "DELIVERY"
                              ? t("PRODUCTS_FILTER_SUPPLY") + " - "
                              : " "}
                            {enquiry?.quantity + " " + t(enquiry?.unit) + " - "}
                            {enquiry?.product?.name}
                          </Title>
                        </FlexRow>
                      </EnquiryHeaderWrapper>
                      {(enquiry?.sellingPrices?.length === "" ||
                        enquiry?.sellingPrices?.length === 0) && (
                        <GridRow
                          column="1fr"
                          gap="0rem"
                          marginTop="20px"
                          marginLeft="20px"
                        >
                          {" "}
                          <GraySpan>{t("ENQUIRY_NO_SELLING_PRICES")}</GraySpan>
                          <Separator marginTop="0px"></Separator>
                        </GridRow>
                      )}

                      {enquiry?.sellingPrices?.length !== "" &&
                        enquiry?.sellingPrices?.map((data, index) => {
                          return (
                            <ServiceSection
                              key={"sellingPriceList_" + index}
                              color={data.isActive === 1 ? "#fff" : "#ededed"}
                            >
                              <GridRow
                                column="auto 90% 1fr"
                                gap="0rem"
                                marginTop="10px"
                              >
                                <CustomCheckBox
                                  id={`quote-selling-price-${parseInt(
                                    data.id,
                                    10
                                  )}`}
                                  dataId={parseInt(data.id, 10)}
                                  onChange={(e) => {
                                    handlePriceSelection(e, data.id, data);
                                  }}
                                  checked={
                                    selectedSellingPrice.indexOf(data.id) !== -1
                                  }
                                />
                                <SellingPriceLabel
                                  color={
                                    data.isActive === 1 ? "#0a4986" : "#767676"
                                  }
                                >
                                  {"#" + data?.id}
                                  {data?.hesusCatalog?.label
                                    ? " - " + data?.hesusCatalog?.label
                                    : ""}
                                  {data?.label ? " - " + data?.label : ""}
                                </SellingPriceLabel>
                                <Image
                                  src={editIcon}
                                  width="25px"
                                  title={t("SELLING_PRICE_ACTION_TOOLTIP_EDIT")}
                                  onClick={() =>
                                    editSellingPriceAction(data, enquiry)
                                  }
                                  alt={t("SELLING_PRICE_ACTION_TOOLTIP_EDIT")}
                                  className="add-quote__quote_action_icon_no_margin"
                                />
                              </GridRow>
                              {data.services?.length !== "" &&
                                data.services?.map((service, indexService) => {
                                  return (
                                    <GridRow
                                      column="41% 1fr 1fr 1fr"
                                      marginBottom={
                                        indexService === 0 ? "1px" : "3px"
                                      }
                                      marginLeft="15px"
                                      key={
                                        "sellingPriceServiceList_" +
                                        index +
                                        indexService
                                      }
                                    >
                                      <MarginDiv marginLeft="30px">
                                        <GrayDarkerServiceSpan
                                          weight="700"
                                          color="#474747"
                                        >
                                          {service?.hesusService?.name}
                                        </GrayDarkerServiceSpan>
                                        <GraySpan>
                                          {service?.hesusService?.needProduct
                                            ? " - " + service?.product?.name
                                            : ""}
                                          {service?.hesusService?.needTransport
                                            ? " - " +
                                              service?.transportType?.name
                                            : ""}
                                        </GraySpan>
                                      </MarginDiv>
                                      <GraySpan textAlign="center">
                                        {addSpace(service.quantity) +
                                          " " +
                                          t(service.unit)}
                                      </GraySpan>
                                      <GraySpan textAlign="center">
                                        {renderPriceWithCurrency(
                                          addSpace(service?.unitPrice),
                                          t(service?.unit),
                                          data?.currency?.symbol,
                                          data?.currency?.position
                                        )}
                                      </GraySpan>
                                      <GrayDarkerSpan
                                        color="#474747"
                                        textAlign="right"
                                      >
                                        {renderPriceWithCurrencyWithoutUnit(
                                          addSpace(service?.totalPrice),
                                          data?.currency?.symbol,
                                          data?.currency?.position
                                        )}
                                      </GrayDarkerSpan>
                                    </GridRow>
                                  );
                                })}
                              <Separator marginTop="0px"></Separator>
                            </ServiceSection>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
            </SectionContainer>
          </OptionsWrapper>
        </FormBody>
        <ButtonWrapper>
          {selectSellingPriceAPIError && (
            <div>{selectSellingPriceAPIError}</div>
          )}

          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={() => onClose("close")}
          >
            {t("CANCEL")}
          </Button>
          <Button
            styles={{
              color: "#fff",
              background: "#0A4986",
              border: "1px solid #ccc",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#04315c",
              },
            }}
            onClick={addSellingPriceAction}
          >
            {t("QUOTE_NEW_PRICE")}
          </Button>
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={() => onClose("validate")}
          >
            <>
              {isSellingPriceSelect && <ClipLoader size={15} color="#fff" />}
              {!isSellingPriceSelect && t("VALIDATE")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

SelectSellingPrice.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};

SelectSellingPrice.defaultProps = {
  id: null,
};
export default withTranslation()(SelectSellingPrice);
